import type { ItemUnitTranslationEntity } from "./ItemUnitTranslationEntity";

export class CreateUpdateItemUnitEntity {
    isActive?: boolean;
    translations?: Array<ItemUnitTranslationEntity> | null;
}